import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ConfirmIndividualTaxInformationRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ConfirmIndividualTaxInformationResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const confirmIndividualTaxInformation = (
  request: ConfirmIndividualTaxInformationRequest,
  options?: CashRequestOptions
) =>
  post<ConfirmIndividualTaxInformationRequest, ConfirmIndividualTaxInformationResponse>(
    '/2.0/cash/confirm-individual-tax-information',
    request,
    { ...options, rejectOnError: true }
  )
